export const RealestatePropertyById = `query RealestateProperty($realestatepropertyid: ID!) {
    realestateProperty(realestatepropertyid: $realestatepropertyid) {
      realestatepropertyid
      photos
      commission
      city
      state
      country
      agents
      floorplan
      agentUsers {
        firstname
        email
        userid
        lastname
        avatar
        phonenumber
        govid
        corporatelicno
      }
      businesses {
        businessentity
        businessname
        businessprice
        businesstype
        contacttype
        entitydescription
        propertybusinessid
        updatedby
        updatedAt
        createdby
        createdAt
        createdUser {
          firstname
          email
          lastname
        }
        updatedUser {
          firstname
          email
          lastname
        }
      }
      zipcode
      builtyear
      cargarage
      bedroom
      bathroom
      price
      mlsid
      currency
      squarefeet
      buyercontacts
      sellercontacts
      status
      fromprice
      toprice
      propertytype
      buildingtype
      ownership
      location
      propertysize
      lotsize
      storeys
      notes
      description
      purchasedate
      purchaseprice
      moveidate
      propertytaxes
      mortgageamount
      mortgageterm
      mortgagerate
      mortgageexpirydate
      saledate
      saleprice
      propertyattribute1
      propertyattribute2
      propertyattribute3
      propertyattribute4
      propertyattribute5
      propertyattribute6
      propertyattribute7
      propertyattribute8
      propertyattribute9
      propertyattribute10
      propertyattribute11
      propertyattribute12
      propertyattribute13
      propertyattribute14
      propertyattribute15
      propertyattribute16
      propertyattribute17
      propertyattribute18
      propertyattribute19
      propertyattribute20
      locationid
      deleted
      businessid
      createdby
      buyerContactList {
        firstname
        lastname
        phonenumber
        phonecountryid
        organization {
          organizationid
          name
        }
        address {
          city
          county
          state {
            name
          }
          street1
          street2
          zip
        }
        contactid
        primaryemail
      }
      sellerContactList {
        firstname
        lastname
        phonenumber
        phonecountryid
        organization {
          organizationid
          name
        }
        address {
          city
          county
          state {
            name
          }
          street1
          street2
          zip
        }
        primaryemail
        contactid
      }
        transactions {
        transactionid
        transactiondate
        documents
        address
        status
        price
        currency
        notes
        commission
        ownershiptype
        commissionamount
        amountforleasepermonth
        noofmonths
        updatedAt
        updatedby
        createdAt
        createdUser {
          firstname
          lastname
        }
          updatedUser {
          firstname
          lastname
        }
      }
      createdAt
      updatedAt
      address
      county
    }
  }`;